import { compareDesc, isValid, parseISO } from 'date-fns';
import type { OneOffCheckReport } from '@/pages/Candidate/view/tables/OneOffChecksTable/types';

const parseCreatedAt = (r: OneOffCheckReport): Date | null => {
  const t = r?.created_at?.trim() ?? '';
  if (!t) return null;
  const d = parseISO(t);
  return isValid(d) ? d : null;
};

/** Newest `created_at` first; rows without a parseable date sort after dated rows; stable tie-break on `id`. */
export const sortOneOffChecksByCreatedAtDesc = (items: OneOffCheckReport[]): OneOffCheckReport[] => {
  return [...items].sort((a, b) => {
    const da = parseCreatedAt(a);
    const db = parseCreatedAt(b);
    if (da == null && db == null) return (a.id ?? 0) - (b.id ?? 0);
    if (da == null) return 1;
    if (db == null) return -1;
    const byDate = compareDesc(da, db);
    if (byDate !== 0) return byDate;
    return (a.id ?? 0) - (b.id ?? 0);
  });
};
